export default __webpack_public_path__ + "images/einstein_logo.13c66612.png";